import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { BCLedgerTopClientRptRequestDto } from "../../../../core/models/reports/bcLedgerTopClientRptRequestDto";
import { CommonModule, DatePipe } from "@angular/common";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ReportsService } from "../../../../core/services/reports.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { TableModule } from "primeng/table";
import { GetYearToYearSummaryTigerDetailsResponse } from "../../../../core/models/reports/getYearToYearSummaryTigerDetailsResponse";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { YearToYearReportBacklogDataResponseDetail } from "../../../../core/models/reports/yearToYearReportBacklogDataResponse";
import {
  YearOverYearSummaryResponse,
  YearToYearSummaryResponseGrid,
} from "../../../../core/models/reports/yearToYearSummaryResponseDto";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { LoaderService } from "../../../../core/services/loader.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Select, SelectModule } from "primeng/select";
import { Employee } from "../../../../core/models/profile/employee";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { RadioButtonModule } from "primeng/radiobutton";

@UntilDestroy()
@Component({
  selector: "jni-year-over-year-report",
  templateUrl: "./year-over-year-report.component.html",
  styleUrls: ["./year-over-year-report.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    SelectModule,
    FormsModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    RadioButtonModule,
    ReactiveFormsModule,
  ],
})
export class YearOverYearReportComponent implements OnInit {
  @ViewChild("filter") filter!: Select;

  bcLedgerForm: BCLedgerTopClientRptRequestDto =
    {} as BCLedgerTopClientRptRequestDto;

  @Input() bcList!: Employee[];
  @Input() bcSelectedId = "";
  @Output() bcLedgerFormEvent =
    new EventEmitter<BCLedgerTopClientRptRequestDto>();

  selectedYearRange!: string;

  yearList: { id: number; name: string }[] = [];
  showReportByClient = false;
  showReportByMonth = false;
  showReportsRadioButtons = false;
  headers: string[] = [];
  reportData: YearOverYearSummaryResponse = {} as YearOverYearSummaryResponse;
  clientReportData: YearToYearSummaryResponseGrid[] = [];
  backlogReportDataDetails: YearToYearReportBacklogDataResponseDetail[] = [];
  backlogReportData: YearToYearSummaryResponseGrid[] = [];
  tigerDetails: GetYearToYearSummaryTigerDetailsResponse =
    {} as GetYearToYearSummaryTigerDetailsResponse;

  revenueYear1Total = 0;
  revenueYear2Total = 0;
  revenueYear3Total = 0;

  GpYear1Total = 0;
  GpYear2Total = 0;
  GpYear3Total = 0;

  GpPercentageYear1Total = 0;
  GpPercentageYear2Total = 0;
  GpPercentageYear3Total = 0;

  GrowthPercentageYear1Total = 0;
  GrowthPercentageYear2Total = 0;
  GrowthPercentageYear3Total = 0;

  showReportSummaryGirds = false;
  reportSelectionRadio = "ByMonth";
  selectedRadioButton = "ByMonth";
  userRole = 0;
  loggedInUserIsBC = false;
  loggedInUserIsAdmin = false;
  currentYear = new Date().getFullYear();
  fiscalYearsList = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];
  constructor(
    public datepipe: DatePipe,
    private _bcledgerService: BcledgerService,
    private _loader: LoaderService,
    private _reportService: ReportsService,
    private _toastr: JniToastrService,
    private _profileFormService: ProfileFormService,
    private _userManagement: UserManagementService
  ) {}

  ngOnInit(): void {
    this.getUserProfile();
    this.initilizeYear();
    this.getBcUser();
  }

  getUserProfile() {
    this._userManagement
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.loggedInUserIsAdmin = true;
        } else {
          this.getUserById(res?.data?.userId);
        }
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: res => {
        if (res?.data) {
          if (
            res?.data?.title?.toLowerCase()?.includes("branding consultant")
          ) {
            this.loggedInUserIsBC = true;
            this.bcSelectedId = res?.data?.personnelNumber || "";
          }
        }
      },
    });
  }

  initilizeYear() {
    const currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    if (
      currentDate.getMonth() + 1 === 1 ||
      currentDate.getMonth() + 1 === 2 ||
      currentDate.getMonth() + 1 === 3
    ) {
      currentYear = currentYear - 1;
    }
    for (let i = currentYear; i >= 2015; i--) {
      this.yearList.push({ id: i, name: i.toString() });
    }
  }

  filterDisabled() {
    if (
      this.bcSelectedId === "" ||
      this.bcSelectedId === null ||
      this.selectedYearRange === "" ||
      this.selectedYearRange === undefined ||
      !this.selectedYearRange
    ) {
      return true;
    }
    return false;
  }

  exportExcelFile() {
    this._loader.setLoaderState(true);
    let reportType = 0;
    if (this.reportSelectionRadio === "ByMonth") {
      reportType = 1; // Enum sets in BE
    } else if (this.reportSelectionRadio === "ByClient") {
      reportType = 2; // Enum sets in BE
    }
    this._reportService
      .getYearToYearSummaryReportExcel(
        this.selectedYearRange,
        this.bcSelectedId,
        reportType
      )
      .subscribe({
        next: res => {
          if (res?.status.toLowerCase() === "success") {
            if (res?.data.length > 0) {
              const binaryData = atob(res.data);

              const blob = new Blob(
                [
                  new Uint8Array(binaryData.length).map((_, index) =>
                    binaryData.charCodeAt(index)
                  ),
                ],
                {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }
              );

              // Create a URL for the blob
              const url = window.URL.createObjectURL(blob);
              this._loader.setLoaderState(false);
              // Create a link element to trigger the download
              const a = document.createElement("a");
              a.href = url;
              a.download = "YearOverYearSummaryReport.xlsx";
              a.click();

              // Revoke the object URL to free up resources
              window.URL.revokeObjectURL(url);
            } else {
              this._loader.setLoaderState(false);
              this._toastr.error("Error", res?.message || "No Data Found");
            }
          }
        },
        error: () => {
          this._loader.setLoaderState(false);
          this._toastr.error("Error", "Error While calling the API");
        },
      });
  }

  getBcUser() {
    this._bcledgerService
      .getAllEmployees()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<Employee[]>) => {
          this.bcList = res.data;
          this.bcList = this.bcList.map(item => ({
            ...item,
            firstNameLastNamePersonalNumber: `${item.firstName} ${item.lastName} (${item.personnelNumber})`,
          }));
        },
      });
  }

  getYearToYearReportByFilter(value: string) {
    this.reportSelectionRadio = value;
    this.onSubmit();
  }

  setHeadersData(selectedYearRange: string) {
    const year = parseInt(selectedYearRange);
    this.headers = [];
    this.headers.push(year.toString());
    this.headers.push((year - 1).toString());
    this.headers.push((year - 2).toString());
  }

  onSubmit() {
    this._loader.setLoaderState(true);
    this.clearObjects();

    if (this.reportSelectionRadio === "ByMonth") {
      this.loadReportByMonth();
    } else if (this.reportSelectionRadio === "ByClient") {
      this.loadReportByClient();
    }
  }

  loadReportByClient() {
    this._reportService
      .getYearToYearSummaryReportByClient(
        this.selectedYearRange,
        this.bcSelectedId
      )
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          if (res?.status?.toLowerCase() === "success") {
            if (
              res?.data?.yearToYearSummaryResponseGrid &&
              res?.data?.yearToYearSummaryResponseGrid?.length > 0
            ) {
              this.reportData = res?.data;
              this.clientReportData = [];
              this.setHeadersData(this.selectedYearRange);
              this.clientReportData = res?.data?.yearToYearSummaryResponseGrid;
              this.showReportsRadioButtons = true;
              this.calculateTotalsByClientReport();
              this.showReportSummaryGirds = true;
              if (this.reportSelectionRadio === "ByClient") {
                this.showReportByClient = true;
                this.showReportByMonth = false;
              }
            } else {
              this.hideGridReports();
              this._toastr.error(
                "Year To Year Summary Report",
                "No record found"
              );
            }
          }
        },
        error: () => {
          this.hideGridReports();
          this._loader.setLoaderState(false);
          this._toastr.error("Error", "Error While calling the API");
        },
      });
  }

  loadReportByMonth() {
    this._reportService
      .getYearToYearSummaryReport(this.selectedYearRange, this.bcSelectedId)
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          if (res?.status?.toLowerCase() === "success") {
            if (
              res?.data?.yearToYearSummaryResponseGrid &&
              res?.data?.yearToYearSummaryResponseGrid?.length > 0
            ) {
              this.clientReportData = [];
              this.setHeadersData(this.selectedYearRange);
              this.reportData = res?.data;
              this.clientReportData = res?.data?.yearToYearSummaryResponseGrid;
              this.showReportsRadioButtons = true;
              this.calculateTotalsByMonthReport();
              this.showReportSummaryGirds = true;
              if (this.reportSelectionRadio === "ByMonth") {
                this.showReportByMonth = true;
                this.showReportByClient = false;
              }
            } else {
              this.hideGridReports();
              this._toastr.error(
                "No record found",
                "Year To Year Summary Report"
              );
            }
          } else {
            this._toastr.error(
              "No record found",
              "Year To Year Summary Report"
            );
          }
        },
        error: () => {
          this.hideGridReports();
          this._loader.setLoaderState(false);
          this._toastr.error("Error", "Error While calling the API");
        },
      });
  }

  loadTigerData() {
    // initially we was gpyear1 in this api but requriement change now pass revenueyear1 in it
    this._reportService
      .getYearToYearSummaryTigerDetails(
        this.selectedYearRange,
        this.GpYear1Total
      )
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          if (res?.status.toLowerCase() === "success") {
            this.tigerDetails = res?.data;
          } else {
            this._toastr.error(res?.message || "No Data found", "Error");
          }
        },
        error: () => {
          this.hideGridReports();
          this._loader.setLoaderState(false);
          this._toastr.error("Error", "Error While calling the tiger API");
        },
      });
  }

  hideGridReports() {
    this.showReportsRadioButtons = false;
    this.showReportSummaryGirds = false;
    this.showReportByClient = false;
    this.showReportByMonth = false;
  }

  clearObjects() {
    this.revenueYear1Total = 0;
    this.revenueYear2Total = 0;
    this.revenueYear3Total = 0;

    this.GpYear1Total = 0;
    this.GpYear2Total = 0;
    this.GpYear3Total = 0;

    this.GpPercentageYear1Total = 0;
    this.GpPercentageYear2Total = 0;
    this.GpPercentageYear3Total = 0;

    this.GrowthPercentageYear1Total = 0;
    this.GrowthPercentageYear2Total = 0;
    this.GrowthPercentageYear3Total = 0;

    this.reportData = {} as YearOverYearSummaryResponse;
    this.clientReportData = [];
    this.tigerDetails = {} as GetYearToYearSummaryTigerDetailsResponse;
    // this.showReportByClient = false;
    // this.showReportByMonth = false;
  }

  calculateTotalsByMonthReport() {
    this.revenueYear1Total = this.clientReportData
      .filter(x => x.revenueYear1 != null && x.revenueYear1 != 0)
      .reduce((total, charge) => total + (charge.revenueYear1 ?? 0), 0);

    this.revenueYear2Total = this.clientReportData
      .filter(x => x.revenueYear2 != 0 && x.revenueYear2 != null)
      .reduce((total, charge) => total + (charge.revenueYear2 ?? 0), 0);

    this.revenueYear3Total = this.clientReportData
      .filter(x => x.revenueYear3 != 0 && x.revenueYear3 != null)
      .reduce((total, charge) => total + (charge.revenueYear3 ?? 0), 0);

    this.GpYear1Total = this.clientReportData
      .filter(x => x.gpYear1 != 0 && x.gpYear1 != null)
      .reduce((total, charge) => total + (charge.gpYear1 ?? 0), 0);

    this.GpYear2Total = this.clientReportData
      .filter(x => x.gpYear2 != 0 && x.gpYear2 != null)
      .reduce((total, charge) => total + (charge.gpYear2 ?? 0), 0);

    this.GpYear3Total = this.clientReportData
      .filter(x => x.gpYear3 != 0 && x.gpYear3 != null)
      .reduce((total, charge) => total + (charge.gpYear3 ?? 0), 0);
    this.GpPercentageYear1Total =
      this.revenueYear1Total &&
      this.revenueYear1Total != 0 &&
      this.revenueYear1Total != null
        ? (this.GpYear1Total / this.revenueYear1Total) * 100
        : 0;
    this.GpPercentageYear2Total =
      this.revenueYear2Total &&
      this.revenueYear2Total != 0 &&
      this.revenueYear2Total != null
        ? (this.GpYear2Total / this.revenueYear2Total) * 100
        : 0;
    this.GpPercentageYear3Total =
      this.revenueYear3Total &&
      this.revenueYear3Total != 0 &&
      this.revenueYear3Total != null
        ? (this.GpYear3Total / this.revenueYear3Total) * 100
        : 0;

    this.GrowthPercentageYear1Total =
      this.GpYear2Total && this.GpYear2Total != 0 && this.GpYear2Total != null
        ? (this.GpYear1Total / this.GpYear2Total) * 100
        : 0;
    this.GrowthPercentageYear2Total =
      this.GpYear3Total && this.GpYear3Total != 0 && this.GpYear3Total != null
        ? (this.GpYear2Total / this.GpYear3Total) * 100
        : 0;

    this.loadTigerData();
  }

  calculateTotalsByClientReport() {
    this.revenueYear1Total = this.clientReportData
      .filter(x => x.revenueYear1 != null && x.revenueYear1 != 0)
      .reduce((total, charge) => total + (charge.revenueYear1 ?? 0), 0);

    this.revenueYear2Total = this.clientReportData
      .filter(x => x.revenueYear2 != 0 && x.revenueYear2 != null)
      .reduce((total, charge) => total + (charge.revenueYear2 ?? 0), 0);

    this.revenueYear3Total = this.clientReportData
      .filter(x => x.revenueYear3 != 0 && x.revenueYear3 != null)
      .reduce((total, charge) => total + (charge.revenueYear3 ?? 0), 0);

    this.GpYear1Total = this.clientReportData
      .filter(x => x.gpYear1 != 0 && x.gpYear1 != null)
      .reduce((total, charge) => total + (charge.gpYear1 ?? 0), 0);

    this.GpYear2Total = this.clientReportData
      .filter(x => x.gpYear2 != 0 && x.gpYear2 != null)
      .reduce((total, charge) => total + (charge.gpYear2 ?? 0), 0);

    this.GpYear3Total = this.clientReportData
      .filter(x => x.gpYear3 != 0 && x.gpYear3 != null)
      .reduce((total, charge) => total + (charge.gpYear3 ?? 0), 0);
    this.GpPercentageYear1Total =
      this.revenueYear1Total &&
      this.revenueYear1Total != 0 &&
      this.revenueYear1Total != null
        ? (this.GpYear1Total / this.revenueYear1Total) * 100
        : 0;
    this.GpPercentageYear2Total =
      this.revenueYear2Total &&
      this.revenueYear2Total != 0 &&
      this.revenueYear2Total != null
        ? (this.GpYear2Total / this.revenueYear2Total) * 100
        : 0;
    this.GpPercentageYear3Total =
      this.revenueYear3Total &&
      this.revenueYear3Total != 0 &&
      this.revenueYear3Total != null
        ? (this.GpYear3Total / this.revenueYear3Total) * 100
        : 0;

    this.GrowthPercentageYear1Total =
      this.GpYear2Total && this.GpYear2Total != 0 && this.GpYear2Total != null
        ? (this.GpYear1Total / this.GpYear2Total) * 100
        : 0;
    this.GrowthPercentageYear2Total =
      this.GpYear3Total && this.GpYear3Total != 0 && this.GpYear3Total != null
        ? (this.GpYear2Total / this.GpYear3Total) * 100
        : 0;

    this.loadTigerData();
  }

  setMonthToThreeLetter(month: number) {
    switch (month) {
      case 1:
        return "Jan";
      case 2:
        return "Feb";
      case 3:
        return "Mar";
      case 4:
        return "Apr";
      case 5:
        return "May";
      case 6:
        return "Jun";
      case 7:
        return "Jul";
      case 8:
        return "Aug";
      case 9:
        return "Sep";
      case 10:
        return "Oct";
      case 11:
        return "Nov";
      case 12:
        return "Dec";
      default:
        return "";
    }
  }

  setTigerTargetValue(from: number, to: number) {
    if (this.GpYear1Total >= from && this.GpYear1Total <= to) {
      return Number((to - (this.GpYear1Total ?? 0)).toFixed(2));
    } else if (this.GpYear1Total < from) {
      return Number((from - (this.GpYear1Total ?? 0)).toFixed(2));
    }
    return 0;
  }

  setSortableColumn(index: number) {
    if (index === 0) {
      return "revenueYear1";
    } else if (index === 1) {
      return "revenueYear2";
    } else if (index === 2) {
      return "revenueYear3";
    }

    return "";
  }
}
